import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    dotDiametr,
    parabolic,
    PARABOLIC_ANIMATION_TIME
 } from '../../initials';
export class ParabolicAnimationCenterTopLeft {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'ParabolicAnimationCenterTopLeft',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.TOP_LEFT,
        };
    }

    getAnimationTime() {
        const layersCount = this.toRowIndex - this.fromRowIndex;
        return layersCount === 1 ? PARABOLIC_ANIMATION_TIME : PARABOLIC_ANIMATION_TIME * layersCount * 0.5;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;
        const levelsCount = this.toRowIndex - this.fromRowIndex;
        const isMostThenOneLevel = levelsCount > 1;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const middleDot = isLeftMovement ? this.dots[this.fromRowIndex][this.fromDotIndex - 1] : this.dots[this.fromRowIndex][this.fromDotIndex + 1];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, 3 * Math.PI / 4);

        return {
            x: parabolic(
                startXY.x, 
                isMostThenOneLevel ? middleDot.dotX : isLeftMovement ? middleDot.dotX + distanceBetweenDots / 2 : middleDot.dotX - distanceBetweenDots / 2 - dotDiametr, 
                endXY.x, 
                Math.pow(t, 1),
            ),
            y: parabolic(
                startXY.y, 
                isMostThenOneLevel ? middleDot.dotY : middleDot.dotY - distanseBetweenLayers, 
                endXY.y, 
                Math.pow(t, 1),
            ),
        };
    }
}